export default __webpack_public_path__ + "static/media/cert_web.218fe991.jpg";